import React from "react";
import styled from "styled-components";
import { LargeButton } from "../components/AppButton";
import config from "../config/app.json";

const BottomSectionWrapper = styled.section`
  background-image: url(${(props) => props.url}),
    linear-gradient(45deg, #f67062, #fc5296);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

const BottomSectionContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 0px;
  flex-wrap: wrap;
  @media (max-width: 425px) {
    padding: 30px 40px;
    box-sizing: border-box;
  }
`;

const BottomSectionTitle = styled.h2`
  font-family: "DM Serif Display Regular", serif;
  font-size: 34px;
  color: #ffffff;
  line-height: normal;
  text-align: center;
  margin: 0px;
`;

const BottomSectionSubText = styled.p`
  font-family: "Lato";
  font-size: 18px;
  margin: 16px 0px;
  color: #fff;
  @media (max-width: 425px) {
    text-align: center;
    line-height: 1.5;
  }
`;

const BottomSmallerText = styled(BottomSectionSubText)`
  font-size: 13px;
  opacity: 0.59;
`;

const authUrl = config["AUTHURLS"][config["AUTHURLS"]["current"]];
const BASE_PATH = process.env.BASE_PATH;

export default function BottomSection({ trackId }) {
  return (
    <BottomSectionWrapper url={`${BASE_PATH}/images/Bottom-BG.svg`}>
      <BottomSectionContainer>
        <BottomSectionTitle>
          Ready to create your first design?
        </BottomSectionTitle>
        <BottomSectionSubText>
          Join a growing bandwagon of a million users who’re creating awesome
          designs every day.
        </BottomSectionSubText>
        <LargeButton
          href={`${authUrl}register/picmaker?trackId=${trackId}`}
          target="_blank"
          rel="noopener"
        >
          Start designing for free
        </LargeButton>
        <BottomSmallerText>
          Free Forever. No Credit Card Required.
        </BottomSmallerText>
      </BottomSectionContainer>
    </BottomSectionWrapper>
  );
}
